import ListItem from "@/components/ListItem";
import SubSectionHeading from "@/components/SubSectionHeading";
import { formatSummaryHeadline, groupCareerIntentSummaryRows } from "./careerIntentCatalog";
import { FORM_SUMMARY_GROUPS, getCareerIntentSummaryRows, type CareerIntentFormValues } from "./careerIntentForm";

export default function CareerIntentSummarySection({
  includeNotes = true,
  values
}: {
  includeNotes?: boolean;
  values: CareerIntentFormValues;
}) {
  const groups = groupCareerIntentSummaryRows(getCareerIntentSummaryRows(values, includeNotes), FORM_SUMMARY_GROUPS);

  return (
    <div className="flex flex-col gap-6" data-testid="career-intent-summary">
      <SubSectionHeading>Your answers so far</SubSectionHeading>
      {groups.map((group) => (
        <div className="flex flex-col gap-2" data-testid={`career-intent-summary-${group.id}`} key={group.id}>
          {group.heading ? <SubSectionHeading>{group.heading}</SubSectionHeading> : null}
          {group.rows.map((row) => (
            <ListItem
              key={row.label}
              overline={`${row.label}:`}
              headline={formatSummaryHeadline(row.values)}
              longContent
            />
          ))}
        </div>
      ))}
    </div>
  );
}
